import Layout from "@/components/Layout";
import CorporateDashboard from "@/components/CorporateDashboard";

export default function Corporate() {
  return (
    <Layout
      title="Dashboard Corporativo"
      subtitle="Compare desempenho entre unidades, redes e franquias"
    >
      <CorporateDashboard />
    </Layout>
  );
}
